import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import { storeData, updateData } from '~/store/modules/perfil/actions';

import Transfer from '../components/TransferList';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [itens, setItens] = useState([]);

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.perfil);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        perf_descricao: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        perf_status: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        itens,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input name="perf_descricao" label="Descrição" />

          <Select
            name="perf_status"
            label="Status"
            options={[
              { label: 'Liberado', value: 1 },
              { label: 'Bloqueado', value: 2 },
              { label: 'Cancelado', value: 3 }
            ]}
          />

          <Transfer
            items={create ? itens : find.itens}
            id={create ? -1 : find.perf_codigo}
            onCallback={(value) => setItens(value)}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
